<template>
  <div>
      <!-- total card -->
    <v-card class="mt-4" v-if="formReport.helperName">
      <v-card-title>
        <h3 class="mr-5">Хелпер:
          <span style="color: #28a745">{{ formReport.helperName }}</span>
        </h3>
        <v-badge
          class="mr-sm-4 my-2 mb-4"
          bordered
          color="success"
          overlap
        >
          <v-chip
            color="info"
            label
            outlined
          >Всего карточек</v-chip>
          <template v-slot:badge>
            {{ formReport.totalCards }}
          </template>
        </v-badge>

        <v-badge
          class="mr-sm-4 my-2 mb-4"
          bordered
          color="success"
          overlap
        >
          <v-chip
            color="info"
            label
            outlined
          >Всего звонков</v-chip>
          <template v-slot:badge>
            {{ formReport.totalCalls }}
          </template>
        </v-badge>

        <v-badge
          class="mr-sm-4 my-2 mb-4"
          bordered
          color="success"
          overlap
        >
          <v-chip
            color="info"
            label
            outlined
          >Процент</v-chip>
          <template v-slot:badge>
            {{ formReport.totalPercent }}%
          </template>
        </v-badge>
      </v-card-title>
    </v-card>

    <!-- table -->
    <v-card
      v-if="report.items.length > 0"
      class="mt-5"
    >
      <v-data-table
        dense
        :items="report.items"
        :headers="report.headers"
        disable-pagination
        hide-default-footer
      />
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "FormStatistics",

  data() {
    return {
      report: {
        headers: [
          {text: 'Имя', value: 'name'},
          {text: 'Кол-во карточек', value: 'countCards'},
          {text: 'Кол-во звонков', value: 'countCalls'},
          {text: 'Разница', value: 'difference'},
          {text: '%', value: 'percent'},
        ],
        items: [],
      },
      expanded: [],
      page: 1,
      pageCount: 0,
      excelLoading: false,
      formsItems: [],
    }
  },

  computed: {
    ...mapGetters({
      loading: 'shared/getLoading',
      formReport: 'form_statistic_report/report',
    }),
  },

  methods: {
    ...mapActions({
      resetAllState: 'resetAllState',
      loadFormStatisticReport: 'form_statistic_report/loadFormStatisticReport',
    }),

    async loadReport(payload) {
      let res = await this.loadFormStatisticReport(payload);

      if (res?.agents !== undefined) {
        this.report.items = res?.agents;
      }
    },
  },

  mounted() {},

  beforeDestroy() {
    this.resetAllState();
  },
}
</script>

<style scoped></style>
